import { useMutation } from '@tanstack/react-query'
import { MainApi } from 'api/MainApi'

const useDeletedMissionPointTransfer = () =>
  useMutation<void, Error, number>({
    mutationFn: MainApi.deleteMissionPointTransferRoute,
  })

export default useDeletedMissionPointTransfer
